export enum LOCAL_STORAGE_KEYS {
    COLOR_PALETTE = 'colorPalette',
    SITES_MAP_COLLAPSED = 'isSitesMapCollapsed',
    SITES_TABLE_VIEW = 'isSitesTableView',
    SITE_PAGE_FILTERS = 'sitePageFilters',
    SHOW_OBSERVATIONS_PANEL = 'showObservationsPanel',
    ANOMALY_MAP_FILTERS = 'anomalyMapFilters',
    DEV_LAST_TOKEN_REFRESH_TIME = 'devLastTokenRefreshTime',
}
